import { BaseContainerModel } from "../base-container.model";
import { bl_wms_packing_list_line_RowInterface, bl_wms_packing_list_line_RowClass } from "../../dbschema/index";

export class WMSPackingListLineContainer extends BaseContainerModel {
    bl_wms_packing_list_line: bl_wms_packing_list_line_RowInterface = new bl_wms_packing_list_line_RowClass();
}
